import { getAdvertisingBidSessions, getBiddingBidSessions } from '../../../services/users'
import { FEEDBACK_ACCEPTED, FEEDBACK_REFUSED } from '../../../components/BidSessions/constants'
import { deleteBidSession, getUnratedBidSessions, giveFeedback, rateUser } from '../../../services/bids'

export default {
  getAdvertisingBidSessions ({ commit }, { id }) {
    return new Promise((resolve, reject) => {
      getAdvertisingBidSessions(id)
        .then(response => {
          const bidSessions = response.data
          commit('setAdvertisingBidSessions', { bidSessions })
          resolve(bidSessions)
        })
        .catch(reject)
    })
  },

  deleteAdvertisingBidSession ({ commit }, { id }) {
    return new Promise((resolve, reject) => {
      deleteBidSession(id)
        .then(() => {
          commit('deleteAdvertisingBidSession', { id })
          resolve(true)
        })
        .catch(reject)
    })
  },

  getBiddingBidSessions ({ commit }, { id }) {
    return new Promise((resolve, reject) => {
      getBiddingBidSessions(id)
        .then(response => {
          const bidSessions = response.data
          commit('setBiddingBidSessions', { bidSessions })
          resolve(bidSessions)
        })
        .catch(reject)
    })
  },

  deleteBiddingBidSession ({ commit }, { id }) {
    return new Promise((resolve, reject) => {
      deleteBidSession(id)
        .then(() => {
          commit('deleteBiddingBidSession', { id })
          resolve(true)
        })
        .catch(reject)
    })
  },

  getUnratedBidSessions ({ commit }, { view }) {
    return new Promise((resolve, reject) => {
      getUnratedBidSessions(view)
        .then(response => {
          const bidSessions = response.data
          commit('setUnratedBidSessions', { bidSessions })
          resolve(bidSessions)
        })
        .catch(reject)
    })
  },

  rateUser ({ commit }, { id, data }) {
    return new Promise((resolve, reject) => {
      rateUser(id, data)
        .then(() => {
          commit('removeUnratedBidSession', { id })
          resolve(true)
        })
        .catch(reject)
    })
  },

  acceptOffer ({ commit }, { id }) {
    return new Promise((resolve, reject) => {
      giveFeedback(id, { feedback: FEEDBACK_ACCEPTED })
        .then(response => {
          const { winnerBidcard, winnerBidder } = response.data
          commit('acceptOffer', { id, winnerBidcard, winnerBidder })
          resolve(true)
        })
        .catch(reject)
    })
  },

  refuseOffer ({ commit }, { id }) {
    return new Promise((resolve, reject) => {
      giveFeedback(id, { feedback: FEEDBACK_REFUSED })
        .then(() => {
          commit('refuseOffer', { id })
          resolve(true)
        })
        .catch(reject)
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/bid-sessions/actions.js